import clsx from "clsx";
import { FavoriteButton } from "./components/FavoriteButton";
import { CardRow } from "../../../CardRow";
import { ProductCardProps } from "../../types";
import { FooterContent } from "./components/FooterContent";

type ProductCardFooterProps = ProductCardProps;

export const productCardFooterTestId = "product-card-footer";

export function ProductCardFooter(props: ProductCardFooterProps) {
  return (
    <CardRow
      className={clsx("p-xs flex items-center min-h-[2.6rem]", {
        "gap-xxs flex": !!props.onFavoriteClick,
      })}
      data-testid={productCardFooterTestId}
    >
      <FooterContent {...props} />

      {!!props.onFavoriteClick && (
        <FavoriteButton
          active={props.isFavorited}
          className="relative z-1"
          onClick={props.onFavoriteClick}
          disabled={props.isFavoritingDisabled}
        />
      )}
    </CardRow>
  );
}
